import { useContext } from 'react';
import { SignupDataContext } from '../contexts/SignupDataContext';

function useSignupData() {
  const context = useContext(SignupDataContext);
  if (context === undefined) {
    throw new Error('useSignupData must be used within a SignupDataProvider');
  }
  return context;
}

export default useSignupData;
